import { render } from "./TimeDisplay.vue?vue&type=template&id=3b1e8cc4"
import script from "./TimeDisplay.vue?vue&type=script&lang=js"
export * from "./TimeDisplay.vue?vue&type=script&lang=js"

import exportComponent from "/opt/atlassian/pipelines/agent/build/frontend/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__